import { UseQueryResult } from "@tanstack/react-query";
import { Result } from "antd";
import { T_Api_Error_Res, T_Api_Success_Res } from "api/api.types";
import { AxiosError } from "axios";
import { ReactElement, ReactNode } from "react";
import { TbAlertCircleFilled, TbLoader2 } from "react-icons/tb";
import { getErrorMessage } from "utils/functions";

export const loader = (
  <div className="flex items-center justify-center p-5">
    <TbLoader2 size={60} className="animate-spin stroke-violet-500" />
  </div>
);
export const loaderSm = <TbLoader2 size={48} className="text-brand-500 animate-spin" />;

export function SingleQueryWrapper<R>({
  query,
  renderData,
  showLoaderOn = "isPending",
  errorExtra,
}: {
  query: UseQueryResult<T_Api_Success_Res<R>["result"]>;
  renderData: (data: R) => ReactElement;
  showLoaderOn?: "isPending" | "isLoading" | "isFetching" | "isRefetching";
  errorExtra?: (error: AxiosError<T_Api_Error_Res>) => ReactNode;
}) {
  if (query[showLoaderOn]) {
    return loader;
  }
  if (query.data) {
    return renderData(query.data);
  } else if (query.error) {
    return (
      <div className="flex items-center justify-center p-5 max-w-[700px] mx-auto">
        <Result
          icon={<TbAlertCircleFilled size={72} className={`mx-auto text-red-500`} />}
          status={"error"}
          // title={query.error.response?.statusText}
          subTitle={getErrorMessage(query?.error)}
          extra={errorExtra?.(query.error)}
        />
      </div>
    );
  } else {
    return loader;
  }
}
